import React, { Fragment } from 'react'
import Categories from '../components/Categories'
export default function Shop() {
  document.title="Shop"
  return (<Fragment>
    <Categories/>
    </Fragment>
  )
}
